/**
 *
 * layout_headerLogoColor.js
 *
 *
 */
(() => {


	/**************************************************************
	 * headerLogoColor
	**************************************************************/
	class LogoWhiteAreaSwitcher {
		constructor(options) {
			this.header = document.querySelector(options.headerSelector);
			this.logo = document.querySelector(options.logoSelector);

			this.whiteAreaSelector = options.whiteAreaSelector || '.js-white-area';
			this.defaultAreaSelector = options.defaultAreaSelector || '.js-default-area';
			this.activeClass = options.activeClass || 'is-logo-white';

			this.ticking = false;

			this.handleScroll = this.onScroll.bind(this);
			this.handleResize = this.onResize.bind(this);
			this.rafUpdate = this.update.bind(this);
		}

		init() {
			if (!this.header || !this.logo) return;

			// this.handleScroll();
			// window.addEventListener('logo', this.handleScroll);
			window.addEventListener('scroll', this.handleScroll, { passive: true });
			window.addEventListener('resize', this.handleResize);

			// this.update();
		}

		onScroll() {
			if (this.ticking) return;
			this.ticking = true;
			requestAnimationFrame(this.rafUpdate);
		}

		onResize() {
			this.update();
		}

		resolveTheme(el) {
			while (el && el !== document.documentElement) {
				if (el.classList && el.classList.contains(this.defaultAreaSelector.replace('.', ''))) {
					return 'default';
				}
				if (el.classList && el.classList.contains(this.whiteAreaSelector.replace('.', ''))) {
					return 'white';
				}
				el = el.parentElement;
			}
			return 'default';
		}

		update() {
			this.ticking = false;

			const rect = this.logo.getBoundingClientRect();
			const x = rect.left + rect.width / 2;
			const y = rect.top + rect.height / 2;

			const list = document.elementsFromPoint(x, y);

			let underEl = null;
			for (let i = 0; i < list.length; i++) {
				if (!this.header.contains(list[i])) {
					underEl = list[i];
					break;
				}
			}

			const theme = underEl ? this.resolveTheme(underEl) : 'default';
			this.header.classList.toggle(this.activeClass, theme === 'white');
		}
	}

	const sw = new LogoWhiteAreaSwitcher({
		headerSelector     : '.l-header',
		logoSelector       : '.l-header__logo',
		whiteAreaSelector  : '.js-white-area',
		defaultAreaSelector: '.js-default-area',
		activeClass        : 'is-logo-white',
	});
	sw.init();








})();
